export default __webpack_public_path__ + "static/media/landNew.ec31fbfb.png";